export default [
    {
        tableName: 'EMPLSALARY',
        description: 'Salary',
    },
    {
        tableName: 'TRAINING',
        description: 'Training',
    },
    {
        tableName: 'SUBJECTS',
        description: 'Subjects',
    },
    {
        tableName: 'TOPICS',
        description: 'Topics',
    },
    {
        tableName: 'BRANCH',
        description: 'Branches',
    },
];